function normalizeEmail(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
}

function parseCanaryEmails(value) {
  return String(value || "")
    .split(",")
    .map(normalizeEmail)
    .filter(Boolean)
}

function mayUseEnhancedMyPage({
  email,
  runtimeProfile,
  canaryEmails,
}) {
  if (runtimeProfile === "staging-parity") {
    return true
  }

  const currentEmail = normalizeEmail(email)
  if (!currentEmail) {
    return false
  }

  return parseCanaryEmails(canaryEmails).includes(currentEmail)
}

module.exports = {
  mayUseEnhancedMyPage,
  normalizeEmail,
  parseCanaryEmails,
}
